
import React from "react";
import { Link } from "@mui/material";

export default function TableLink({ children, onClick, disabled = false }) {
    return (
        <Link
            component="button"
            underline="always"
            onClick={disabled ? undefined : onClick}
            sx={{
                fontFamily: "'Roboto Condensed', sans-serif",
                fontSize: 14,
                textTransform: "uppercase",
                fontWeight: 700,
                color: disabled ? "#111111" : "#111111",
                cursor: disabled ? "default" : "pointer",
                background: "none",
                border: "none",
                padding: 0,
                m: 0,

                "&:hover": {
                    color: disabled ? "#111111" : "#111111",
                    textDecoration: disabled ? "none" : "underline",
                },
            }}
        >
            {children}
        </Link>
    );
}
